import './components/progress-rail';
import 'flag-icons/css/flag-icons.min.css';
import { SlideRouter } from './engine/router';
import { Sidebar } from './components/sidebar';
import { mountLanguagePicker } from './components/language-picker';
import { attachHighlightTranslator } from './engine/highlight-translator';

const app = must<HTMLElement>('app');
const headerRail = app.querySelector('.header-rail') as HTMLElement;

const shell = {
  root: must<HTMLElement>('slide-root'),
  unitLabel: must<HTMLElement>('unit-label'),
  prev: must<HTMLButtonElement>('btn-prev'),
  next: must<HTMLButtonElement>('btn-next'),
  rail: headerRail,
};

const sidebar = new Sidebar({
  app,
  list: must<HTMLElement>('module-list'),
  rail: must<HTMLElement>('course-rail'),
  progressLabel: must<HTMLElement>('course-progress-label'),
  menuToggle: must<HTMLButtonElement>('btn-menu'),
  closeButton: must<HTMLButtonElement>('btn-sidebar-close'),
  scrim: must<HTMLElement>('sidebar-scrim'),
});

mountLanguagePicker(must<HTMLElement>('native-language'));
attachHighlightTranslator(shell.root);

void Promise.all([
  sidebar.start(),
  new SlideRouter(shell).start(),
]).catch((error) => {
  shell.root.innerHTML = `
    <div class="card">
      <p class="eyebrow">Could not load the lesson</p>
      <h1 class="slide-title">Check your connection and refresh.</h1>
      <p class="slide-instruction">${escapeHtml(error instanceof Error ? error.message : String(error))}</p>
    </div>
  `;
});

if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js');
  });
}

function must<T extends HTMLElement>(id: string): T {
  const el = document.getElementById(id);
  if (!el) throw new Error(`Missing #${id}`);
  return el as T;
}

function escapeHtml(value: string): string {
  return value.replace(/[&<>"]/g, (ch) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[ch]!);
}
